app.service('defaultBreadcrumbs', ['$location', 'authHelper', 'CONSTANTS',
  function ($location, authHelper, CONSTANTS) {
    const defaultBreadcrumbsService = this;

    // Origin-aware parents for the IDI pages. Derived from the static entries rather than
    // re-listed, so a new page or origin cannot be added to one list and missed in the other.
    // Kept outside getBreadcrumb so these loops do not add to that function's complexity.
    function addIdiOriginParents(parent_lookup) {
      const idi_project_pages = Object.keys(parent_lookup).filter((key) => key.startsWith('IDI Project '));
      const origins = Object.entries(CONSTANTS.idiOriginScreens);

      for (const page of idi_project_pages) {
        for (const [segment, origin] of origins) {
          parent_lookup[page + '__from_' + segment] = origin;
        }
      }

      // A stakeholder's records hang off the IDI tab, so they follow whichever origin that tab
      // was reached with rather than resetting to IDI Projects.
      for (const [segment] of origins) {
        parent_lookup['IDI Records__from_' + segment] = 'IDI Project IDI__from_' + segment;
      }
    }

    defaultBreadcrumbsService.getBreadcrumb = function (start, extra_url_lookup, extra_text_lookup) {
      const ret = [];

      const url_lookup = {
        'New Disease Area': '#/Admin/DiseaseAreas/0',  // we can't tell which id should be here.
        'Edit Disease Area': '',  // we can't tell which id should be here.
        'Manage Disease Areas': '#/Admin/DiseaseAreas',

        'New Client FAQ': '#/Admin/ClientFAQ/0',
        'Edit Client FAQ': '', // we can't tell which id should be here.
        'Manage Client FAQ\'s': '#/Admin/ClientFAQs',
        'New Payer FAQ': '#/Admin/PayerFAQ/0',
        'Edit Payer FAQ': '', // we can't tell which id should be here.
        'Manage Payer FAQ\'s': '#/Admin/PayerFAQs',

        'New Expertise': '#/Admin/Functional Expertise/0',  // we can't tell which id should be here.
        'Edit Expertise': '',  // we can't tell which id should be here.
        'Manage Expertise': '#/Admin/FunctionalExpertise',
        'Honorarium Payments': '#/Admin/HonorariumPayments',

        'Edit Payer': '',
        'New Third-Party Payer': '#/Admin/ThirdPartyPayer/Edit/0',
        'Edit Third-Party Payer': '',
        'View Payer': '#/Admin/Payer/View',

        'Help': '',

        'System Administration': '#/Admin',
        'Open Surveys': '#/Admin/OpenSurveys',

        'Login': '#/Login',

        // payer portal
        'My Account': '#/Payers/MyAccount',
        'New Surveys': '#/Payers/NewSurveys',
        'Surveys in Progress__payer': '#/Payers/ProgressSurveys',
        'My Profile': '#/Payers/MyProfile',
        'Edit My Profile': '#/Payers/EditProfile',
        'Payer Referral': '#/Payers/Referral',
        'My Expertise': '#/Payers/Expertise',

        'Dashboard__admin': '#/Administration',
        'Dashboard__payer': '#/Payers',
        'Dashboard__client': '#/Client',

        'Home': '#/Login',
        'Home__admin': '#/',
        'Home__client': '#/Client',
        'Home__payer': '#/Payers',
        'Clarification Requests': '#/Payers/Clarifications',

        // client
        'Surveys in Development': '#/Client/InDevelopment',
        'Document Repository__client': '#/Client/DocumentRepository',
        'Surveys in Progress__client': '#/Client/InProgress',
        'Completed & Closed Surveys': '#/Client/CompletedSurveys',

        // admin
        'Forecasting': '#/Admin/Forecasting',
        'Document Repository__admin': '#/Admin/DocumentRepository',
        'Surveys in Development__admin': '#/Admin/SurveysInDevelopment',
        'IDI Projects__admin': '#/Admin/IDIProjects',
        'Export Responses': '#/Admin/ExportResponses/Survey/:id',
        'All Surveys': '#/Admin/AllSurveys',
        'Manage Clients and Client Users': '#/Admin/Clients',
        'Manage Genesis Research Users': '#/Admin/Users',
        'Manage Page Content': '#/Admin/PageContent',
        'Manage Question Bank': '#/Admin/QuestionBank',
        'Manage Licences': '#/Admin/Licences',
        'Upgrade Licence': '#/Admin/Licence/Upgrade/:id',
        'View Licence': '#/Admin/Licence/:id',
        'Live Surveys': '#/Admin/LiveSurveys',
        'Global Scales__admin': '#/Admin/GlobalScales',
        'Clone Disclaimer__admin': '#/Admin/CloneDisclaimer',
        'Global Disclaimers__admin': '#/Admin/GlobalDisclaimers',
        'Global Disclaimers Template Authoring__admin': '#/Admin/Disclaimer/:id',
        'Manage Rating Scales__admin': '/Admin/RatingScale/:id',
        'Manage Drag and Drop Ranking Scales__admin': '/Admin/DragDropRanking/:id',
        'Manage Radio Button Ranking Scales__admin': '/Admin/RadioRanking/:id',
        'AdminClone Surveys': '#/Admin/CloneSurveys',
        'Survey General Information': '#/Admin/Survey/:id/Project',
        'PayerAndCountry': '#/Admin/Survey/:id/PayerAndCountry',
        'Survey Licences': '#/Admin/Survey/:id/Licences',
        'Survey Disclaimers': '#/Admin/Survey/:id/Disclaimers',
        'Milestones': '#/Admin/Survey/:id/Milestones',
        'Questionnaires': '#/Admin/ManageQuestions/:id/:client_id',
        'Survey Notes': '#/Admin/Survey/:id/Notes',
        'Fusion': '#/Admin/Survey/:id/Fusion',
        'Survey Client Folder': '#/Admin/Survey/:id/ClientFolder',
        'Manage Survey Respondents': '#/Admin/Survey/:id/Respondents',
        'Survey Respondents': '#/Admin/Survey/:id/Respondents',
        'Client Statement Report Options': '#/Admin/Reports/ClientStatementOptions',
        'Reports': '#/Admin/ReportsList',
        'Advanced Payer Selection': '#Admin/AdvancedPayerSelection',
        'Advanced Search': '#Admin/AdvancedSearch',
        'Expertise Detail': '#/Admin/Payer/Expertise/:id',
        'Survey Charges': '#/Admin/Survey/:id/Charges'
      };

      const parent_lookup = {
        'New Disease Area': 'Manage Disease Areas',
        'Edit Disease Area': 'Manage Disease Areas',
        'Edit Payer': 'Advanced Payer Selection',
        'New Third-Party Payer': 'Advanced Payer Selection',
        'Edit Third-Party Payer': 'Advanced Payer Selection',
        'View Payer': 'Advanced Payer Selection',
        'Payer Statistics': 'Advanced Payer Selection',
        'Manage Disease Areas': 'System Administration',
        'Edit My Profile': 'My Profile',
        'Payer Referral': 'Dashboard',
        'My Expertise': 'Dashboard',

        'New Client FAQ': 'Manage Client FAQ\'s',
        'Edit Client FAQ': 'Manage Client FAQ\'s',
        'Manage Client FAQ\'s': 'System Administration',
        'New Payer FAQ': 'Manage Payer FAQ\'s',
        'Edit Payer FAQ': 'Manage Payer FAQ\'s',
        'Manage Payer FAQ\'s': 'System Administration',

        'New Expertise': 'Manage Expertise',
        'Edit Expertise': 'Manage Expertise',
        'Manage Expertise': 'System Administration',

        'Open Surveys': 'Dashboard',
        'Forecasting' : 'Dashboard',
        'Manage Survey Respondents': 'Open Surveys',

        'System Administration': 'Home',
        'Home': null,
        'Login': null,
        'Forgotten Password': 'Login',
        'Password Reset': 'Login',
        'Create First Password': 'Login',
        'Forgotten Username': 'Login',

        'FAQs': 'Home',
        'FAQs__payer': 'Dashboard',
        'FAQs__client': 'Dashboard',
        'FAQs__admin': 'Dashboard',

        //payer portal

        'Disclaimer': 'New Surveys',
        'View Survey__progress': 'Surveys in Progress',
        'View Survey__new': 'New Surveys',
        'My Account': 'Dashboard',
        'Surveys in Progress': 'Dashboard',
        'Survey History': 'Dashboard',
        'New Surveys': 'Dashboard',
        'Setup TFA__login': 'Login',
        'Setup TFA': 'Change Password',
        'Dashboard': null,
        'Survey Already Submitted': 'Dashboard',
        'My Profile': 'Dashboard',

        'Help': 'Home',
        'Help__payer': 'Dashboard',
        'Help__client': 'Dashboard',
        'Help__admin': 'Dashboard',

        'Survey Submitted': 'Dashboard',
        'Clarification Requests': 'Dashboard',
        'View Survey__clarifications': 'Clarification Requests',

        // client portal
        'Welcome to Genesis Research Group': 'Dashboard',
        'Surveys in Development': 'Dashboard',
        'Completed & Closed Surveys': 'Dashboard',
        'Preview Survey__draft__client': 'Surveys in Development',
        'Preview Survey__submitted_for_approval__client': 'Surveys in Development',
        'Preview Survey__live__client': 'Surveys in Progress',
        'Test Survey as a Payer': 'Surveys in Development',
        'Pilot Testing Successful': 'Surveys in Development',
        'Edit Survey - New': 'Dashboard',
        'Create Survey': 'Surveys in Development',
        'Configure Survey': 'Surveys in Development',
        'Reorder Questions': 'Edit Survey',
        'Edit Rating Scale__question': 'Edit Survey',
        'Edit Rating Scale__manage': 'Manage Scales',
        'Edit Ranking Scale__manage': 'Manage Scales',
        'Edit Drag and Drop Ranking__manage': 'Manage Scales',
        'Edit Drag and Drop Ranking__question': 'Edit Survey',
        'Edit Radio Button Ranking__question': 'Edit Survey',
        'Edit Table of Responses__question': 'Edit Survey',
        'Manage Rating Scales__client': 'Manage Scales',
        'Manage Drag and Drop Ranking Scales__client': 'Manage Scales',
        'Manage Radio Button Ranking Scales__client': 'Manage Scales',
        'Survey Deleted': 'Dashboard',
        'Survey Not Found': 'Dashboard',
        'Survey Sent For Approval': 'Dashboard',
        'Document Repository__client': 'Dashboard',
        'Client__Edit Document': 'Document Repository__client',
        'Edit Document__edit_questions': 'Edit Survey',
        'Edit Document__create_survey': 'Create Survey',
        'Edit Document__edit_survey': 'Edit Survey',
        'View Survey__responses': 'Surveys in Progress',
        'View Survey__responses_complete': 'Completed & Closed Surveys',
        'View Survey__responses_closed': 'Completed & Closed Surveys',
        'Clone Survey': 'Dashboard',
        'Clarification Requests & Responses': 'Dashboard',
        'View Survey__client_clarifications': 'Clarification Requests & Responses',
        'Manage Disclaimer Templates': 'Dashboard',
        'Manage Disclaimers__From_Survey': 'Edit Survey__client',
        'Edit Disclaimer__manage': 'Manage Disclaimer Templates',
        'Edit Disclaimer__survey': 'Configure Survey',
        'Manage Credit Allocation': 'Dashboard',
        'Clone Surveys': 'Dashboard',

        // admin portal
        'Draft Projects': 'Dashboard',
        'Honorarium Payments': 'Dashboard',
        'Surveys for approval': 'Dashboard',
        'Expertise Detail': 'Advanced Payer Selection',
        'All Surveys': 'Dashboard',
        'Live Surveys': 'Dashboard',
        'Reports': 'Dashboard',
        'Advanced Payer Selection': 'Dashboard',
        'Advanced Search': 'Dashboard',
        'Document Repository__admin': 'Dashboard',
        'Surveys in Development__admin': 'Dashboard',
        'IDI Projects__admin': 'Dashboard',
        'Clone IDI Projects': 'IDI Projects__admin',
        'IDI Project General Information': 'IDI Projects__admin',
        'IDI Project Scope Countries': 'IDI Projects__admin',
        'IDI Project Milestones': 'IDI Projects__admin',
        'IDI Project IDI': 'IDI Projects__admin',
        'IDI Project Notes': 'IDI Projects__admin',
        'IDI Records': 'IDI Project IDI',
        'Admin__Edit Document': 'Document Repository__admin',
        'View Survey__admin': 'Surveys for approval',
        'View Survey__all_responses_admin': 'All Surveys',
        'View Survey__all_responses_from_LiveSurveys': 'Live Surveys',
        'Project Brief__from_AllSurveys': 'All Surveys',
        'Draft Survey__from_AllSurveys': 'All Surveys',
        'Project Brief__from_DraftProjects': 'Draft Projects',
        'Draft Survey__from_DraftProjects': 'Draft Projects',
        'View Responses': 'Dashboard',
        'View Responses__from_LiveSurveys': 'Live Surveys',
        'Clarification requests for review': 'Dashboard',
        'View Survey__clar_requests_for_review': 'Clarification requests for review',
        'Clarification responses for review': 'Dashboard',
        'View Survey__clar_responses': 'Clarification responses for review',
        'Report Details': 'All Surveys',
        'Report Details__from_LiveSurveys': 'Live Surveys',
        'Issues for review': 'Dashboard',
        'Import Payers': 'Advanced Payer Selection',
        'Impersonate User': 'Dashboard',
        'Import Payment Information': 'System Administration',
        'Global Scales__admin': 'Dashboard',
        'Clone Disclaimer__admin': 'Dashboard',
        'Global Disclaimers__admin': 'Dashboard',
        'Global Disclaimers Template Authoring__admin': 'Global Disclaimers__admin',
        'Edit Disclaimer Template': 'Manage Disclaimer Templates',
        'Manage Rating Scales__admin': 'Global Scales',
        'Manage Drag and Drop Ranking Scales__admin': 'Global Scales',
        'Manage Radio Button Ranking Scales__admin': 'Global Scales',
        'Manage Clients and Client Users': 'System Administration',
        'Manage Genesis Research Users': 'System Administration',
        'Edit Client': 'Manage Clients and Client Users',
        'Edit Client__manage': 'Manage Clients and Client Users',
        'View Client': 'Manage Clients and Client Users',
        'Edit Client User': 'Manage Clients and Client Users',
        'Edit Client User__manage': 'Manage Clients and Client Users',
        'View Client User': 'Manage Clients and Client Users',
        'Edit Genesis Research User': 'Manage Genesis Research Users',
        'Manage Page Content': 'System Administration',
        'Edit Page': 'Manage Page Content',
        'Manage Question Bank': 'System Administration',
        'New Question': 'Manage Question Bank',
        'Edit Question': 'Manage Question Bank',
        'Edit Licence for': 'View Licence',
        'Upgrade Licence for': 'View Licence',
        'Adjustments': 'View Licence',
        'Transfer Credits': 'View Licence',
        'View Licence': 'Manage Licences',
        'Credit Allocation': 'Manage Licences',
        'Credit Allocation__view_client': 'View Client',
        'Credit Allocation__view_client_user': 'View Client User',
        'Manage Credits': 'Credit Allocation',
        'Login Attempts': 'System Administration',
        'Forgotten Password Attempts': 'System Administration',
        'Additional Fees': 'Advanced Payer Selection',
        'Questions from other Surveys': 'Dashboard',
        'Questions from other Surveys__Surveys_Edit': 'Edit Survey__admin',
        'Edit Survey__admin': 'Surveys in Development__admin',
        'Preview Survey__draft__admin': 'Surveys in Development__admin',
        'Preview Survey__submitted_for_approval__admin': 'Surveys in Development__admin',
        'Survey General Information': 'Surveys in Development__admin',
        'Payer And Country': 'Surveys in Development__admin',
        'Survey Licences': 'Surveys in Development__admin',
        'Survey Disclaimers': 'Surveys in Development__admin',
        'Milestones': 'Surveys in Development__admin',
        'Survey Charges': 'Surveys in Development__admin',
        'Questionnaires': 'Surveys in Development__admin',
        'Fusion': 'Surveys in Development__admin',
        'Preview Survey': 'Surveys in Development__admin',
        'Survey Notes': 'Surveys in Development__admin',
        'Survey Client Folder': 'Surveys in Development__admin',
        'Survey Cancellation': 'Surveys in Development__admin',
        'Survey Respondents': 'Open Surveys',
        'Responses': 'Open Surveys',
        'Client Statement Report Options': 'Reports'
      };

      addIdiOriginParents(parent_lookup);

      const user_type_name = authHelper.getUserType();

      for (let current = start; current != null; current = parent_lookup[current]) {
        const current2 = current + '__' + user_type_name;

        if (current2 in parent_lookup) {
          current = current2;
        }

        let url = (current2 in url_lookup) ? url_lookup[current2] : url_lookup[current];

        // this is for urls with dynamic parameters
        if (!url && extra_url_lookup && current in extra_url_lookup) {
          url = extra_url_lookup[current];
        }

        let item_text = current.split('__')[0];

        if (extra_text_lookup && current in extra_text_lookup) {
          item_text = item_text + ' - ' + extra_text_lookup[current];
        }

        if (current === start) {
          url = '#' + $location.path();
        }

        ret.unshift([item_text, url]);
      }

      return ret;
    };
  }]
);
